/** Reveal the single Judge.me widget before badge/hash navigation. No API writes. */
(function () {
  if (window.adenzoReviewTabsLoaded) return;
  window.adenzoReviewTabsLoaded = true;
  function reveal(root, scroll) {
    var panel = root && root.querySelector('[data-adenzo-reviews-panel]');
    if (!panel) return;
    var details = panel.closest('details');
    if (details) details.open = true;
    else {
      var trigger = root.querySelector('[data-adenzo-reviews-trigger]');
      if (trigger) trigger.click();
    }
    requestAnimationFrame(function () {
      window.dispatchEvent(new Event('resize'));
      if (scroll) panel.scrollIntoView({ block: 'start', behavior: 'auto' });
    });
  }
  document.addEventListener('click', function (event) {
    var badge = event.target.closest('.jdgm-preview-badge, a[href="#judgeme_product_reviews"]');
    if (!badge) return;
    var root = badge.closest('.main-product-template');
    if (!root || !root.querySelector('[data-adenzo-reviews-panel]')) return;
    event.preventDefault();
    // The vendor's default scroll handler cannot open the theme's hidden panel.
    event.stopImmediatePropagation();
    reveal(root, true);
  }, true);
  function fromHash() {
    if (location.hash === '#judgeme_product_reviews') reveal(document.querySelector('.main-product-template'), true);
  }
  window.addEventListener('hashchange', fromHash);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fromHash, { once: true });
  else fromHash();
})();
